module.exports = [{"id":0,"institute":"Taylor's University","date-graduated":"December 2018","title":"Bachelor's Degree in Computer Science","grade":"<abbr title=\"Cumulative Grade Point Average\">CGPA</abbr> 3.88/4.00"}]


//////////////////
// WEBPACK FOOTER
// ./app/assets/js/database/education.json
// module id = w+aE
// module chunks = 2